import ActionTypes, {MattersActionTypes} from "../constants/action_types";

export type MattersClearAction = {
  type: MattersActionTypes["MATTERS_CLEAR"]["SUCCESS"];
  payload: undefined;
};

export default function clearMatters() {
  return {
    type: ActionTypes.MATTERS_CLEAR.SUCCESS,
  };
}
